import {Component, HostBinding, Input} from '@angular/core';
import {MatMenuModule} from "@angular/material/menu";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {IntakeStatus} from "intake-shared";

/** "Pill" display of a transcription's state */
@Component({
	selector: 'intake-status-pill',
	imports: [
		MatMenuModule,
		MatIconModule,
		MatButtonModule
	],
	templateUrl: 'intake-status-pill.html',
	standalone: true,
	styleUrl: './intake-status-pill.scss'
})
export class IntakeStatusPillComponent {
	/** Class to set for the component */
	@HostBinding("class")
	class:string;

	/** Text for the pill */
	text:string;


	/** The current status of the intake */
	@Input()
	set status(value:IntakeStatus) {
		switch(value) {
			case IntakeStatus.Complete:
				this.text = "Complete";
				this.class = "complete";
				break;

			case IntakeStatus.InProgress:
				this.text = "In Progress";
				this.class = "in-progress";
				break;

			case IntakeStatus.NotStarted:
				this.text = "Not Started";
				this.class = "not-started";
				break;

			case IntakeStatus.NotStartedWarning:
				this.text = "Not Started";
				this.class = "not-started-warning";
				break;

			case IntakeStatus.CompleteCheckedOut:
				this.text = "Complete";
				this.class = "complete-checked-out";
				break;
		}
	}
}
